import React, { useState } from 'react';
import SettingsNavLinks from './SettingsNavlink';


const Settings = () => {
  const [activeTitle, setActiveTitle] = useState('Email');

  return (
    <>
      {/* <HeaderCardContent name={`Billing - ${activeTitle}`} /> */}
      <SettingsNavLinks setActiveTitle={setActiveTitle} />
    </>
  );
};

export default Settings;
